export enum PanelNames {
  UNIT_NODE_SELECTION_SHAPE = 'UNIT_NODE_SELECTION_SHAPE',

  INFO_PANEL_TITLE = 'INTO_PANEL_TITLE',
  INFO_PANEL_SHAPE = 'INFO_PANEL_SHAPE',

  FLOW_PROPERTIES_SIZE_TABLE_TITLE = 'FLOW_PROPERTIES_SIZE_TABLE_TITLE',
  FLOW_PROPERTIES_PXX_TABLE_TITLE = 'FLOW_PROPERTIES_PXX_TABLE_TITLE',
  FLOW_PROPERTIES_GRAPH_TITLE = 'FLOW_PROPERTIES_GRAPH_TITLE',

  PARTICLE_SIZE_DISTRIBUTION_SIZE_LIST = 'PARTICLE_SIZE_DISTRIBUTION_SIZE_LIST',
  PARTICLE_SIZE_DISTRIBUTION_SIZE_GRAPH = 'PARTICLE_SIZE_DISTRIBUTION_SIZE_GRAPH',
}
